import { render, staticRenderFns } from "./PersonalInfoCollectKind.vue?vue&type=template&id=3bf9f9be&scoped=true"
import script from "./PersonalInfoCollectKind.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectKind.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectKind.vue?vue&type=style&index=0&id=3bf9f9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9f9be",
  null
  
)

export default component.exports